import { useEffect } from 'react';
import { Editor } from './components/Editor';
import { Preview } from './components/Preview';
import { InstallPrompt } from './components/InstallPrompt';
import { LivePreview } from './components/LivePreview';
import { useAppStore } from './lib/store';

export function App() {
  const { config, isRecording, setIsRecording, isMobile, setIsMobile } = useAppStore();

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 1024);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [setIsMobile]);

  const handleRecord = () => {
    if (!config.text.trim()) return;
    setIsRecording(true);
  };

  const handleFinishRecording = (blob: Blob) => {
    setIsRecording(false);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `poetic-video-${Date.now()}.mp4`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="app-shell min-h-dvh text-foreground selection:bg-primary/30">
      <main
        className="mx-auto grid min-h-dvh w-full max-w-[1600px] grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(380px,42vw)]"
      >
        <section className="editor-pane min-h-0 relative flex flex-col">
          <Editor />
        </section>

        {!isMobile && (
          <aside className="preview-rail order-first lg:order-0 relative flex flex-col">
            <LivePreview config={config} onRecord={handleRecord} />
          </aside>
        )}
      </main>

      <Preview
        config={config}
        isRecording={isRecording}
        onFinishRecording={handleFinishRecording}
        onCancel={() => setIsRecording(false)}
      />

      <InstallPrompt />
    </div>
  );
}
